// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_header {
  margin-top: 40px;
}

.carousel-container {
  width: 100%;
  max-width: 800px; /* Tamaño máximo para pantallas grandes */
  margin: 0 auto; /* Centrar en la pantalla */
  position: relative;
}

.carousel-slide {
  position: relative;
  display: flex;
  justify-content: center; /* Centrar la imagen horizontalmente */
  align-items: center; /* Centrar la imagen verticalmente */
  overflow: hidden;
}

.carousel-image {
  max-width: 90%; /* Ajusta la imagen al contenedor */
  height: auto; /* Mantén las proporciones */
  object-fit: cover; /* Recorta la imagen para que ocupe el espacio */
  border-radius: 20px;
  margin: auto;
}

.carousel-caption {
  position: absolute;
  margin-left: -40px;
  margin-bottom: -10px;
  display: inline;
  background: rgba(162, 209, 224, 0.75); /* Fondo semitransparente */
  color: #fff;
  border-radius: 5px;
  max-width: 233px;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.carousel-caption h2 {
  font-size: 2rem;
  margin: 0;
}

@media (max-width: 768px) {
  .carousel-container {
    max-width: 100%; /* Asegúrate de que ocupe toda la pantalla */
  }

  .carousel-caption
  {
    max-width: 170px;
  }

  .carousel-caption h2 {
    font-size: 1.5rem; /* Reduce el tamaño del texto en pantallas pequeñas */
  }

  .contenedor_fila {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: center;
    width: 100%; /* Asegura que ocupe todo el ancho del contenedor padre */
    gap: 10px; /* Espacio entre los contenedores, opcional */
  }

  .centrar_texto {
    margin-left: 0px;
    margin-right: 0px;
  }

  .centrar_texto2 {
    margin: 0px;
  }
}

.titulo_grande {
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 3.0rem;
  font-weight: bold;
  color: black;
}

.titulo {
  font-size: 1.4rem;
  color:  #a2d1e0;
  margin-bottom: 20px;
  font-weight: bold;
}

.texto{
  font-size: 1.2rem;
  color: black;
  text-align: justify;
}


.titulo2 {
  font-size: 1.4rem;
  color:  black;
  margin-bottom: 20px;
  font-weight: bold;
}

.texto2 {
  font-size: 1.2rem;
  color: white;
  text-align: justify;
}

.box {
  flex: 1 1; /* Hace que ambos contenedores crezcan por igual */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box; /* Asegura que padding no afecte el tamaño total */
  padding: 25px;
  margin-bottom: 50px;
}

.centrar_texto {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 5px;
}

.centrar_texto2 {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: #a2d1e0;
  border-radius: 5px;
}

.contenedor_fila {
  flex: 1 1;
  text-align: center;
  width: 100%; /* Asegura que ocupe todo el ancho del contenedor padre */
  margin-top: 50px;
  margin-bottom: 50px;  
}

.box2 {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box; /* Asegura que padding no afecte el tamaño total */
  background-color: #a2d1e0;
  padding: 25px;
  margin-bottom: 50px;  
}



.quote {
  position: relative; /* Para posicionar el triángulo */
  display: inline-block; /* Ajusta el tamaño al contenido */
  background-color: white;
  color: black;
  max-width: 60%;
  border: 8px double black; /* Borde doble */
  border-radius: 10px; /* Esquinas redondeadas */
  padding: 20px; /* Espacio interno */
  text-align: center;
  font-family: Arial, sans-serif;
  font-size: 1.2em;
  margin: 20px;
  font-style: italic;
}

.quote::after {
  content: "";
  position: absolute;
  bottom: -28px; /* Ubicación debajo del contenedor */
  left: 20px; /* Ajusta la posición horizontal del triángulo */
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 20px 20px 0 20px; /* Triángulo apuntando hacia abajo */
  border-color: black transparent transparent transparent; /* Triángulo negro */
}

.contenedor_global {
  margin-top: 50px;
  width: 100%;
}

.autor {
  position: relative; /* Posición relativa al contenedor */
  bottom: -10px; /* Cerca del borde inferior */
  right: 0px; /* Alineado a la derecha */
  font-size: 0.9em; /* Tamaño de letra más pequeño */
  font-weight: bold; /* Resaltar el autor */
  color: white; /* Texto en blanco */
  background-color: black; /* Fondo negro para destacar */
  padding: 5px 10px; /* Espaciado alrededor del texto */
  border-radius: 5px; /* Bordes redondeados */
}

.autor > a{
  color:crimson;
}

.salto {
  margin-top: 50px;
  margin-bottom: 50px;
}

.centrado {
  display: block;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin-left: 5%;
  margin-right: 5%;
}

.logos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* Espaciado entre los logos */
  justify-content: center;
  padding: 20px;
  background-color: #a2d1e0;
  border: 16px double white; /* Borde doble */
  border-radius: 50px;
}

/* Cada logo ocupa el 50% del ancho en pantallas pequeñas */
.logo-item {
  flex: 0 0 50%; /* 2 logos por fila */
  max-width: 50%;
  display: flex;
  justify-content: center; /* Centra el logo horizontalmente */
  align-items: center; /* Centra el logo verticalmente */
  border-radius: 5px;
}

/* Imagen dentro del logo */
.logo-img {
  max-width: 150px;
  max-height: 150px;
  min-width: 150px;
  min-height: 150px;
  object-fit:cover; /* Asegura que las imágenes mantengan su proporción */
  border-radius: 20px;
}

/* En pantallas grandes, cada logo ocupa el 25% del ancho */
@media (min-width: 768px) {
  .logo-item {
    flex: 0 0 25%; /* 4 logos por fila */
    max-width: 25%;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,yCAAyC;EAC3D,cAAc,EAAE,2BAA2B;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB,EAAE,sCAAsC;EAC/D,mBAAmB,EAAE,oCAAoC;EACzD,gBAAgB;AAClB;;AAEA;EACE,cAAc,EAAE,mCAAmC;EACnD,YAAY,EAAE,4BAA4B;EAC1C,iBAAiB,EAAE,gDAAgD;EACnE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,qCAAqC,EAAE,2BAA2B;EAClE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,eAAe,EAAE,4CAA4C;EAC/D;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB,EAAE,qDAAqD;EAC1E;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW,EAAE,yDAAyD;IACtE,SAAS,EAAE,6CAA6C;EAC1D;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO,EAAE,kDAAkD;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB,EAAE,kDAAkD;EAC1E,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,WAAW,EAAE,yDAAyD;EACtE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB,EAAE,kDAAkD;EAC1E,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;;;AAIA;EACE,kBAAkB,EAAE,iCAAiC;EACrD,qBAAqB,EAAE,kCAAkC;EACzD,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,wBAAwB,EAAE,gBAAgB;EAC1C,mBAAmB,EAAE,yBAAyB;EAC9C,aAAa,EAAE,oBAAoB;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa,EAAE,oCAAoC;EACnD,UAAU,EAAE,gDAAgD;EAC5D,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,8BAA8B,EAAE,oCAAoC;EACpE,uDAAuD,EAAE,oBAAoB;AAC/E;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;EACxD,aAAa,EAAE,6BAA6B;EAC5C,UAAU,EAAE,0BAA0B;EACtC,gBAAgB,EAAE,gCAAgC;EAClD,iBAAiB,EAAE,sBAAsB;EACzC,YAAY,EAAE,oBAAoB;EAClC,uBAAuB,EAAE,8BAA8B;EACvD,iBAAiB,EAAE,kCAAkC;EACrD,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,8BAA8B;EACzC,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,yBAAyB,EAAE,gBAAgB;EAC3C,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa,EAAE,qBAAqB;EACpC,cAAc;EACd,aAAa;EACb,uBAAuB,EAAE,mCAAmC;EAC5D,mBAAmB,EAAE,iCAAiC;EACtD,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB,EAAE,qDAAqD;EACvE,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE;IACE,aAAa,EAAE,qBAAqB;IACpC,cAAc;EAChB;AACF","sourcesContent":[".container_header {\r\n  margin-top: 40px;\r\n}\r\n\r\n.carousel-container {\r\n  width: 100%;\r\n  max-width: 800px; /* Tamaño máximo para pantallas grandes */\r\n  margin: 0 auto; /* Centrar en la pantalla */\r\n  position: relative;\r\n}\r\n\r\n.carousel-slide {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center; /* Centrar la imagen horizontalmente */\r\n  align-items: center; /* Centrar la imagen verticalmente */\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-image {\r\n  max-width: 90%; /* Ajusta la imagen al contenedor */\r\n  height: auto; /* Mantén las proporciones */\r\n  object-fit: cover; /* Recorta la imagen para que ocupe el espacio */\r\n  border-radius: 20px;\r\n  margin: auto;\r\n}\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  margin-left: -40px;\r\n  margin-bottom: -10px;\r\n  display: inline;\r\n  background: rgba(162, 209, 224, 0.75); /* Fondo semitransparente */\r\n  color: #fff;\r\n  border-radius: 5px;\r\n  max-width: 233px;\r\n  justify-content: center;\r\n  text-align: center;\r\n  align-items: center;\r\n}\r\n\r\n.carousel-caption h2 {\r\n  font-size: 2rem;\r\n  margin: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .carousel-container {\r\n    max-width: 100%; /* Asegúrate de que ocupe toda la pantalla */\r\n  }\r\n\r\n  .carousel-caption\r\n  {\r\n    max-width: 170px;\r\n  }\r\n\r\n  .carousel-caption h2 {\r\n    font-size: 1.5rem; /* Reduce el tamaño del texto en pantallas pequeñas */\r\n  }\r\n\r\n  .contenedor_fila {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n    width: 100%; /* Asegura que ocupe todo el ancho del contenedor padre */\r\n    gap: 10px; /* Espacio entre los contenedores, opcional */\r\n  }\r\n\r\n  .centrar_texto {\r\n    margin-left: 0px;\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .centrar_texto2 {\r\n    margin: 0px;\r\n  }\r\n}\r\n\r\n.titulo_grande {\r\n  margin-top: 30px;\r\n  margin-bottom: 20px;\r\n  font-size: 3.0rem;\r\n  font-weight: bold;\r\n  color: black;\r\n}\r\n\r\n.titulo {\r\n  font-size: 1.4rem;\r\n  color:  #a2d1e0;\r\n  margin-bottom: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.texto{\r\n  font-size: 1.2rem;\r\n  color: black;\r\n  text-align: justify;\r\n}\r\n\r\n\r\n.titulo2 {\r\n  font-size: 1.4rem;\r\n  color:  black;\r\n  margin-bottom: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.texto2 {\r\n  font-size: 1.2rem;\r\n  color: white;\r\n  text-align: justify;\r\n}\r\n\r\n.box {\r\n  flex: 1; /* Hace que ambos contenedores crezcan por igual */\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  box-sizing: border-box; /* Asegura que padding no afecte el tamaño total */\r\n  padding: 25px;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.centrar_texto {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: white;\r\n  border-radius: 5px;\r\n}\r\n\r\n.centrar_texto2 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #a2d1e0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.contenedor_fila {\r\n  flex: 1;\r\n  text-align: center;\r\n  width: 100%; /* Asegura que ocupe todo el ancho del contenedor padre */\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;  \r\n}\r\n\r\n.box2 {\r\n  margin-top: 100px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  box-sizing: border-box; /* Asegura que padding no afecte el tamaño total */\r\n  background-color: #a2d1e0;\r\n  padding: 25px;\r\n  margin-bottom: 50px;  \r\n}\r\n\r\n\r\n\r\n.quote {\r\n  position: relative; /* Para posicionar el triángulo */\r\n  display: inline-block; /* Ajusta el tamaño al contenido */\r\n  background-color: white;\r\n  color: black;\r\n  max-width: 60%;\r\n  border: 8px double black; /* Borde doble */\r\n  border-radius: 10px; /* Esquinas redondeadas */\r\n  padding: 20px; /* Espacio interno */\r\n  text-align: center;\r\n  font-family: Arial, sans-serif;\r\n  font-size: 1.2em;\r\n  margin: 20px;\r\n  font-style: italic;\r\n}\r\n\r\n.quote::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -28px; /* Ubicación debajo del contenedor */\r\n  left: 20px; /* Ajusta la posición horizontal del triángulo */\r\n  width: 0;\r\n  height: 0;\r\n  border-style: solid;\r\n  border-width: 20px 20px 0 20px; /* Triángulo apuntando hacia abajo */\r\n  border-color: black transparent transparent transparent; /* Triángulo negro */\r\n}\r\n\r\n.contenedor_global {\r\n  margin-top: 50px;\r\n  width: 100%;\r\n}\r\n\r\n.autor {\r\n  position: relative; /* Posición relativa al contenedor */\r\n  bottom: -10px; /* Cerca del borde inferior */\r\n  right: 0px; /* Alineado a la derecha */\r\n  font-size: 0.9em; /* Tamaño de letra más pequeño */\r\n  font-weight: bold; /* Resaltar el autor */\r\n  color: white; /* Texto en blanco */\r\n  background-color: black; /* Fondo negro para destacar */\r\n  padding: 5px 10px; /* Espaciado alrededor del texto */\r\n  border-radius: 5px; /* Bordes redondeados */\r\n}\r\n\r\n.autor > a{\r\n  color:crimson;\r\n}\r\n\r\n.salto {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.centrado {\r\n  display: block;\r\n  justify-content: center;\r\n  text-align: center;\r\n  align-items: center;\r\n  margin-left: 5%;\r\n  margin-right: 5%;\r\n}\r\n\r\n.logos-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 20px; /* Espaciado entre los logos */\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background-color: #a2d1e0;\r\n  border: 16px double white; /* Borde doble */\r\n  border-radius: 50px;\r\n}\r\n\r\n/* Cada logo ocupa el 50% del ancho en pantallas pequeñas */\r\n.logo-item {\r\n  flex: 0 0 50%; /* 2 logos por fila */\r\n  max-width: 50%;\r\n  display: flex;\r\n  justify-content: center; /* Centra el logo horizontalmente */\r\n  align-items: center; /* Centra el logo verticalmente */\r\n  border-radius: 5px;\r\n}\r\n\r\n/* Imagen dentro del logo */\r\n.logo-img {\r\n  max-width: 150px;\r\n  max-height: 150px;\r\n  min-width: 150px;\r\n  min-height: 150px;\r\n  object-fit:cover; /* Asegura que las imágenes mantengan su proporción */\r\n  border-radius: 20px;\r\n}\r\n\r\n/* En pantallas grandes, cada logo ocupa el 25% del ancho */\r\n@media (min-width: 768px) {\r\n  .logo-item {\r\n    flex: 0 0 25%; /* 4 logos por fila */\r\n    max-width: 25%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
